import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAssignTagNotificationState = createStateReducer(initialState, {
  [events.assignTagSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "assignTag",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.assignTagFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "assignTag",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceAssignTagNotificationState };
